import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useEffect, useRef, useState } from 'react'
import { get, post } from '../../../helpers/request'

import { Form } from '../../../components/Form/Form'
import MultiSelect from '../../../components/MultiSelect/MultiSelect'
import MultiSelectItem from '../../../components/MultiSelect/MultiSelectItem'
import t from '../../../helpers/i18n.js'
import { withRouter } from 'react-router-dom'

const AddDivisionTeamView = ({ history, match }) => {
  const [[teamsState, teams], setTeams] = useVisualState()
  const [formValid, setFormValid] = useState(false)
  const teamData = useRef({})
  const divisionId = match.params.divisionId

  const handleAddTeam = () => {
    post(
      '/soccer/competitions/divisions/' + divisionId + '/teams',
      teamData.current
    )
      .then((response) => {
        history.push('/soccer/competitions/divisions/' + divisionId)
      })
      .catch((error) => {
        // TODO: better error handling
        console.log(error)
      })
  }

  useEffect(() => {
    setTeams(LOADING)
    get('/soccer/competitions/divisions/' + divisionId + '/teams/available')
      .then((response) => {
        setTeams(READY, response)
      })
      .catch((error) => {
        setTeams(ERROR, error)
      })
  }, [setTeams, divisionId])

  return (
    <div>
      <h3>{t('titles.Add_a_teams_to_a_division')}</h3>
      <Form data={teamData} onValidityChange={setFormValid} required>
        {teamsState === READY && (
          <MultiSelect name='teams' label={t('labels.Select_teams_to_add')} required>
            {teams.map((team) => (
              <MultiSelectItem key={team.team_id} value={team.team_id}>
                {team.name}
              </MultiSelectItem>
            ))}
          </MultiSelect>
        )}
      </Form>
      <div>
        <button disabled={!formValid} onClick={handleAddTeam}>
          {t('buttons.Add_teams')}
        </button>
      </div>
    </div>
  )
}

export default withRouter(AddDivisionTeamView)
